import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { RadioButton } from 'primereact/radiobutton';
import { Divider } from 'primereact/divider';
import Objetivos from "./Objetivos";
import Services from "../../service/Services";
import BtnCrearEntregables from "./BtnCrearEntregables";
import ConfirmBtn from "./ConfirmBtn.js";
import BtnActualizarEntregables from './BtnActualizarEntregables'
import Cookies from "universal-cookie";
import { UseMedia } from "../Funciones";
import axios from "axios";
const cookies = new Cookies();


const ConsultarEntregables = ({ permissionsProp, fullTableProp, individualMonthReportProp, idProjectProp, projectProp, getClientsProp, dateStartValidityProp, dateEndValidityProp,
    setSelectedDeliverableProp, objectMonthlyReportDataProp, readReportProp, listReportsUsersProp, reloadObjectiveProp, setDisabledIndexProp, disabledIndexProp,
    selectedDeliverableProp, deliverablesProp, objectivesProp, projectsUserSessionProp, runRenderBlockProp, setRunRenderBlockProp, showAllDataProp, loadingProp,
    monthlyReportDataAllDataProp, emptyObjectivesProp, selectedObjectiveProp, servicesDeliverablesProp, dateStartMonthlyReportProp, dateEndMonthlyReportProp }) => {

    const [deliverables, setDeliverables] = useState([]);
    const [loading, setLoading] = useState(true);

    const[isMonthlyRep,setisMonthlyRep] = useState(true)
    const [projects,setProjects] = useState([])
    const [loadingProj,setloadingProj] = useState(true)

    const getServices = new Services();

    const [runRender, setRunRender] = useState(0)

    const usuario = cookies.get('usuario')

    const userRole = cookies.get('code')

    useEffect(() => {
        if(getClientsProp === undefined && showAllDataProp === undefined) setisMonthlyRep(false)
    }, [getClientsProp, showAllDataProp]);// eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {

        const fetchProjects = async() =>{
            setloadingProj(true)
            let info = await getServices.getAsociacionProyectoUsuarioVigente();
            if(info !== undefined){
                return info
            }
        }
    
        if(isMonthlyRep === false){
            fetchProjects().then(fetchedProjects =>{
                const projectOptions = fetchedProjects.map(proj =>({
                    label: proj.nombre,
                    value: proj.id
                }));
                setProjects(projectOptions)
                setloadingProj(false)
            }).catch(error =>{
                // console.error('Error fetching...',error);
            });
        }
    
    },[isMonthlyRep]) // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
        let source;
        if (showAllDataProp === true && servicesDeliverablesProp !== undefined) {
            setDeliverables(servicesDeliverablesProp)
            setLoading(false)
        }
        return () => {
            if (source !== undefined && source) {
                getServices.cancelRequest()
            }
        }

    }, [runRender, servicesDeliverablesProp, showAllDataProp, individualMonthReportProp])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (showAllDataProp === false) {
            let deliverables = [];
            try {
                if (readReportProp === true && listReportsUsersProp.length !== 0) {
                    // Parsear los entregables guardados
                    const deliverableData = JSON.parse(listReportsUsersProp[0].entregables);
                    // Crear un mapa de deliverablesProp para acceso rápido por id
                    const deliverablesPropMap = new Map(deliverablesProp.map(item => [item.id, item]));
    
                    // Filtrar y combinar los entregables
                    deliverables = deliverableData
                        .map(obj => deliverablesPropMap.get(obj.id)) // Obtener el entregable correspondiente de deliverablesProp
                        .filter(Boolean) // Eliminar undefined (en caso de que no exista en deliverablesProp)
                        .filter(obj => 
                            obj.objetivos.some(objective => objective.proyecto.id === idProjectProp) // Filtrar por proyecto
                        );
                } else {
                    // Filtrar entregables desde deliverablesProp
                    deliverables = deliverablesProp.filter(item =>
                        item.objetivos.some(j => j.proyecto.id === parseInt(idProjectProp))
                    );
                }
    
                // Eliminar duplicados (si es necesario)
                const uniqueDeliverables = Array.from(new Set(deliverables.map(item => item.id)))
                    .map(id => deliverables.find(item => item.id === id));
    
                // Filtrar por creador (opcional)
                const newUniqueDataCreatedBy = uniqueDeliverables.filter(object => object.creadopor === usuario);
                const newUniqueDataNoCreatedBy = uniqueDeliverables.filter(object => object.creadopor !== usuario);
                const sendData = [...newUniqueDataCreatedBy, ...newUniqueDataNoCreatedBy];
    
                setDeliverables(sendData);
            } catch (error) {
                // console.error("Error parsing entregables:", error);
                setDeliverables([]); // En caso de error, establecer un array vacío
            }
            setLoading(false);
        }
    }, [showAllDataProp, readReportProp, listReportsUsersProp, deliverablesProp, idProjectProp, usuario]);

    var newSelectedObjectiveProp = selectedObjectiveProp?.filter(obj => obj.proyecto === idProjectProp)

    const dt = useRef(null);

    const [selectedDeliverable, setSelectedDeliverable] = useState(null);

    const onRowSelect = (e) => {
        var objectiveFilter = []
        objectivesProp.forEach(x => {
            e.data.objetivos.forEach(y => {
                if (x.id === y.objetivo.id) {
                    objectiveFilter.push(x)
                }
            })
        })
        var objectiveFilterProject = []
        objectiveFilter.forEach(element => {
            const result = element.proyectos.filter(function (object) {
                var id = parseInt(object.proyecto.id);
                return id === parseInt(idProjectProp);
            });
            result.forEach((i) => {
                objectiveFilterProject.push(element);
            });
        })

        var objectiveProject = objectiveFilterProject.map(item => {
            return {
                descripcion: item.descripcion,
                id: item.id,
                proyectos: item.proyectos.filter(object => object.proyecto.id === parseInt(idProjectProp))
            }
        })

        var sendObjectives = []
        e.data.objetivos.forEach(x => {
            objectiveProject.forEach(y => {
                sendObjectives.push({
                    id: x.id,
                    fechacumplimiento: x.fechacumplimiento,
                    porcentajecumplimiento: x.porcentajecumplimiento,
                    objetivo: {
                        descripcion: y.descripcion,
                        id: y.id,
                        porcentajecumplimiento: y.proyectos[0].porcentajecumplimiento
                    },
                    proyecto: {
                        id: x.proyecto.id
                    }
                })
            })
        })

        const tableData = {}
        const uniqueData = sendObjectives.filter(function (object) {
            return tableData.hasOwnProperty(object.objetivo.id) ? false : (tableData[object.objetivo.id] = true)
        })

        var newObject = {
            id: e.data.id,
            descripcion: e.data.descripcion,
            objetivos: uniqueData,
            proyecto: idProjectProp,
        }
        setSelectedDeliverableProp([...selectedDeliverableProp, newObject])
    }

    const onRowUnselect = (e) => {
        const result = selectedDeliverableProp.filter(function (object) {
            var id = object.id
            var idProject = object.proyecto
            return id !== e.data.id || idProject !== e.data.proyecto
        })
        setSelectedDeliverableProp(result)
    }

    const onSelectedDeliverableChange = (e) => {
        setSelectedDeliverable(e.value)
        if (e.type === "all") {
            var filterProject = e.value.map(z => {
                return {
                    actualizadopor: z.actualizadopor,
                    creadopor: z.creadopor,
                    descripcion: z.descripcion,
                    estado: z.estado,
                    fechaactualizado: z.fechaactualizado,
                    fechacreacion: z.fechacreacion,
                    id: z.id,
                    objetivos: z.objetivos.filter(object => object.proyecto.id === parseInt(idProjectProp)),
                    proyecto: z.proyecto,
                }
            })
            var sendData = filterProject.map(item => {
                var objectiveFilter = []
                item.objetivos.forEach(y => {
                    objectivesProp.forEach(x => {
                        if (x.id === y.objetivo.id) {
                            objectiveFilter.push(x)
                        }
                    })
                })
                var objectiveProject = objectiveFilter.map(item => {
                    return {
                        descripcion: item.descripcion,
                        id: item.id,
                        proyectos: item.proyectos.filter(object => object.proyecto.id === parseInt(idProjectProp))
                    }
                })
                var sendObjectives = []
                item.objetivos.forEach(x => {
                    objectiveProject.forEach(y => {
                        sendObjectives.push({
                            id: x.id,
                            fechacumplimiento: x.fechacumplimiento,
                            porcentajecumplimiento: x.porcentajecumplimiento,
                            objetivo: {
                                descripcion: y.descripcion,
                                id: y.id,
                                porcentajecumplimiento: y.proyectos[0].porcentajecumplimiento
                            },
                            proyecto: {
                                id: x.proyecto.id
                            }
                        })
                    })
                })
                const tableData = {}
                const uniqueData = sendObjectives.filter(function (object) {
                    return tableData.hasOwnProperty(object.objetivo.id) ? false : (tableData[object.objetivo.id] = true)
                })
                return {
                    descripcion: item.descripcion,
                    id: item.id,
                    objetivos: uniqueData,
                    proyecto: idProjectProp
                }
            })
            if (e.value.length !== 0) {
                var arrayData = selectedDeliverableProp.concat(sendData)
                var arrayDataMap = arrayData.map(item => {
                    return [JSON.stringify(item), item]
                })
                var arrayDataMapArr = new Map(arrayDataMap)
                var uniqueData = [...arrayDataMapArr.values()]
                setSelectedDeliverableProp(uniqueData)
            } else {
                setDisabledIndexProp(true)
                var newDeliverable = deliverables.map(item => {
                    return {
                        id: item.id,
                        proyecto: idProjectProp
                    }
                })
                var newData = []
                for (var i = 0; i < selectedDeliverableProp.length; i++) {
                    var equal = false;
                    for (var j = 0; j < newDeliverable.length & !equal; j++) {
                        if (selectedDeliverableProp[i]['id'] === newDeliverable[j]['id'] &&
                            selectedDeliverableProp[i]['proyecto'] === newDeliverable[j]['proyecto'])
                            equal = true;
                    }
                    if (!equal) newData.push(selectedDeliverableProp[i]);
                }
                setSelectedDeliverableProp(newData)
            }
        }

        if (e.value.length !== 0) {
            setDisabledIndexProp(true)
        }
    }

    useEffect(() => {
        if (objectMonthlyReportDataProp !== undefined) {
            var arrayDeliverable = JSON.parse(objectMonthlyReportDataProp.entregables)
            var result = arrayDeliverable.filter(function (object) {
                var idProject = object.proyecto
                return String(idProject) === String(idProjectProp)
            })
            setSelectedDeliverable(result)
            setSelectedDeliverableProp(JSON.parse(objectMonthlyReportDataProp.entregables))

        } else {
            setSelectedDeliverable([])
            if (setSelectedDeliverableProp !== undefined) {
                setSelectedDeliverableProp([])
            }
        }
    }, [objectMonthlyReportDataProp, setSelectedDeliverableProp, idProjectProp])

    var permissionsDeliverableCreate
    if (permissionsProp[19].permisos[0] === "Crear") {
        permissionsDeliverableCreate = true
    } else {
        permissionsDeliverableCreate = false
    }
    var permissionsDeliverableUpdate
    if (permissionsProp[19].permisos[1] === "Editar") {
        permissionsDeliverableUpdate = true
    } else {
        permissionsDeliverableUpdate = false
    }
    var permissionsDeliverableDelete
    if (permissionsProp[19].permisos[2] === "Eliminar") {
        permissionsDeliverableDelete = true
    } else {
        permissionsDeliverableDelete = false
    }

    var permissionsColumnActions
    if (permissionsDeliverableDelete === false && permissionsDeliverableUpdate === false) {
        permissionsColumnActions = false
    } else {
        permissionsColumnActions = true
    }

    const acctions = (rowData) => {
        var uniqueFilterDeliverable = []
        if (monthlyReportDataAllDataProp) {
            var monthlyReportDataAllDataPropDeliverable = monthlyReportDataAllDataProp.map(item => {
                return {
                    entregables: JSON.parse(item.entregables)
                }
            })

            var filterDeliverable = []
            const result = monthlyReportDataAllDataPropDeliverable.map(item => {
                return item.entregables.map(j => {
                    var boolean
                    if (j.id === rowData.id) {
                        boolean = item
                    }
                    return boolean
                })

            })
            result.forEach(i => {
                i.forEach(j => {
                    if (j !== undefined) {
                        if (j.length !== 0) {
                            filterDeliverable.push(j)
                        }
                    }
                })
            })
            uniqueFilterDeliverable = [...new Set(filterDeliverable)]
        }

        var noDeleteSDeliverable = false
        var messagDelete = '¿Está seguro de eliminar este entregable?, Recuerde que una vez se elimine, se borrará definitivamente del sistema'
        if (rowData.creadopor !== usuario) {
            noDeleteSDeliverable = true
            messagDelete = 'No puede eliminar registros creados por otro usuario'
        } else if (uniqueFilterDeliverable.length !== 0) {
            noDeleteSDeliverable = true
            messagDelete = 'No puede eliminar este entregable por que ya ha sido usado por otro usuario'
        }

        return (
            <>
                {permissionsDeliverableUpdate ?
                    readReportProp ?
                        null
                        :

                        <BtnActualizarEntregables
                            projectsProp={rowData.objetivos}
                            idDeliverableProp={rowData.id}
                            deliverableProp={rowData.descripcion}
                            creationDateProp={rowData.fechacreacion}
                            createdByProp={rowData.creadopor}
                            idProjectProp={idProjectProp}
                            projectProp={projectProp}
                            individualMonthReportProp={individualMonthReportProp}
                            setRunRenderProp={setRunRender}
                            runRenderProp={runRender}
                            runRenderBlockProp={runRenderBlockProp}
                            setRunRenderBlockProp={setRunRenderBlockProp}
                            listDeliverableProp={deliverables}
                            listObjectivesProp={rowData.objetivos}
                            dataDeliverableProp={individualMonthReportProp ? deliverablesProp : deliverables}
                        />
                    :
                    ""
                }

                <Objetivos
                    objectivesProp={rowData.objetivos}
                    idDeliverableProp={rowData.id}
                    deliverableProp={rowData.descripcion}
                    creationDateProp={rowData.fechacreacion}
                    createdByProp={rowData.creadopor}
                    idProjectProp={idProjectProp}
                    projectProp={projectProp}
                    individualMonthReportProp={individualMonthReportProp}
                    setRunRenderProp={setRunRender}
                    runRenderProp={runRender}
                    readReportProp={readReportProp}
                    reloadObjectiveProp={reloadObjectiveProp}
                    deliverablesProp={deliverablesProp}
                    runRenderBlockProp={runRenderBlockProp}
                    setRunRenderBlockProp={setRunRenderBlockProp}
                    listObjectivesProp={objectivesProp}
                    dateStartMonthlyReportProp={dateStartMonthlyReportProp}
                    dateEndMonthlyReportProp={dateEndMonthlyReportProp}
                />

                {permissionsDeliverableDelete ?
                    readReportProp ?
                        null
                        :
                        <ConfirmBtn
                            tittle="Confirmar Eliminación"
                            menssage={messagDelete}
                            action="Delete"
                            label=""
                            classProp="p-button-danger"
                            icon="pi pi-trash"
                            tooltipProp="Eliminar"
                            idDeliverableProp={rowData.id}
                            setRunRenderProp={setRunRender}
                            runRenderProp={runRender}
                            runRenderBlockProp={runRenderBlockProp}
                            setRunRenderBlockProp={setRunRenderBlockProp}
                            noDeleteSDeliverableProp={noDeleteSDeliverable}
                        />
                    :
                    ""
                }

            </>
        )
    }

    const [globalFilter, setGlobalFilter] = useState(null);

    const handleChange = (e) => {
        e.preventDefault();
    };

    // proceso para exportar datos por Excel


    const exportExcel = () => {

        const newArrWithOutId = deliverablesProp.map(item => {
            const { id, ...rest } = item; // Usamos destructuring para excluir la propiedad 'id'
            return rest;
        })
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(newArrWithOutId);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'Datos');
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

    const header = (

        <div className="headerTable">
            {permissionsDeliverableCreate ?
                showAllDataProp ?
                    null
                    :
                    readReportProp ?
                        null
                        :
                        emptyObjectivesProp || isMonthlyRep === false?
                            null
                            :
                            newSelectedObjectiveProp?.length !== 0 &&
                            <BtnCrearEntregables
                                idProjectProp={idProjectProp}
                                projectProp={projectProp}
                                getClientsProp={getClientsProp}
                                dateStartValidityProp={dateStartValidityProp}
                                dateEndValidityProp={dateEndValidityProp}
                                individualMonthReportProp={individualMonthReportProp}
                                setRunRenderProp={setRunRender}
                                runRenderProp={runRender}
                                reloadObjectiveProp={reloadObjectiveProp}
                                runRenderBlockProp={runRenderBlockProp}
                                setRunRenderBlockProp={setRunRenderBlockProp}
                                deliverablesProp={deliverablesProp}
                                newDeliverablesProp={deliverables}
                                objectivesProp={objectivesProp}
                                projectsUserSessionProp={projectsUserSessionProp}
                                listDeliverableProp={deliverables}
                            />
                :
                ""
            }
            {loading === true ? <p>Cargando información...</p> : ''}
            {showAllDataProp ?
                <Button type="button" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success p-mr-2" data-pr-tooltip="XLSX" />
                :
                null
            }
            <div>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." className="p-column-filter" keyfilter={/^[^<>*!=°|(#$%&"_)+-.:;,/?¡¿'{}]+$/}
                        onCut={handleChange} onCopy={handleChange} onPaste={handleChange}
                    />
                </span>
            </div>
        </div>
    );
    let small = UseMedia("(max-width: 760px)");

    const [projectFilter, setProjectFilter] = useState('');
    const cancelTokenSourceRef = useRef(null);
    const [viewOption, setViewOption] = useState('multiSelect'); 

    const fetchDeliverables = (projectIds) => {
        setLoading(true);
        
        // Cancelar solicitud anterior si existe
        if (cancelTokenSourceRef.current) {
            cancelTokenSourceRef.current.cancel();
        }
        
        // Crear nuevo token de cancelación
        const source = axios.CancelToken.source();
        cancelTokenSourceRef.current = source;
        
        // Asignar el mismo token al servicio
        getServices.source = source;  // Sincronizar los tokens
        
        setDeliverables([]);
        
        return getServices.getDeliverablesByProjects(projectIds)
            .then(data => {
                if (cancelTokenSourceRef.current === source) {
                    setDeliverables(data);
                    setLoading(false);
                }
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    // console.log('Request canceled', error.message);
                } else {
                    // console.error('Error fetching objectives:', error);
                }
            })
    };
    
    useEffect(() => {

        if(isMonthlyRep === false){
            if (!projectFilter || projectFilter.length === 0) {
                setLoading(true);
                setDeliverables([]);
                return;
            }

            fetchDeliverables(projectFilter);
        }
        return () => {
            if (cancelTokenSourceRef.current) {
                cancelTokenSourceRef.current.cancel();
            }
        };
    }, [runRender,projectFilter]);// eslint-disable-line react-hooks/exhaustive-deps
    
    const handleProjectsChange = (e) => {
        setProjectFilter(e.value);
    };
    
    const handleViewOptionChange = (e) => {
        
        const newValue = e.value;
        setViewOption(newValue);
        
        setDeliverables([]);
        setLoading(true);
        
        // Cancelar cualquier solicitud pendiente después de actualizar el viewOption
        if (cancelTokenSourceRef.current) {
            cancelTokenSourceRef.current.cancel();
        }
        
        // Limpiar projectFilter si cambia la vista
        if (projectFilter && projectFilter.length > 0) {
            setLoading(true);
            setProjectFilter([]);
        }
        
        // Realizar la nueva solicitud solo después de completar las cancelaciones anteriores
        if (newValue === 'showAllDeliverables') {
            // Usar setTimeout para asegurar que esta acción ocurra en el siguiente ciclo de eventos
            setTimeout(() => {
                fetchAllDeliverables();
            }, 0);
        }
    };
    
    const fetchAllDeliverables= async () => {
        // Cancelar solicitud anterior si existe
        if (cancelTokenSourceRef.current) {
            cancelTokenSourceRef.current.cancel();
        }
    
        // Crear nuevo token de cancelación
        const source = axios.CancelToken.source();
        cancelTokenSourceRef.current = source;
        
        // Asignar el mismo token al servicio
        getServices.source = source;  // Sincronizar los tokens
    
        setLoading(true);
        setDeliverables([]);      
        try {
            let deliverables = await getServices.getDeliverables();
            if (cancelTokenSourceRef.current === source) {
                setDeliverables(deliverables);
                setLoading(false);
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                // console.log('Request canceled', error.message);
            } else {
                // console.error('Error fetching all objectives:', error);
            }
        }
    };

    return (
        <div className="datatable-responsive-demo">
            <div className="card">
                <div className="p-field p-col-12 p-lg-12" style={{ marginBottom: '1rem' }}>
                    {isMonthlyRep === false && (
                        <>
                            {userRole.toLowerCase().includes('admin') || userRole.toLowerCase().includes('super') ? (
                                <>
                                    <div className="p-grid" style={{ alignItems: 'start', marginBottom: '0.5rem' }}>
                                        <div className="p-col">
                                            <div className="p-field-radiobutton" style={{ marginBottom: '0.5rem' }}>
                                                <RadioButton
                                                    inputId="multiSelectView"
                                                    name="viewOption"
                                                    value="multiSelect"
                                                    onChange={handleViewOptionChange}
                                                    checked={viewOption === 'multiSelect'}
                                                />
                                                <label className="labels" htmlFor="multiSelectView" style={{ fontWeight: '100', marginLeft: '0.5rem' }}>
                                                    Seleccionar Proyectos
                                                </label>
                                            </div>
                                            <div className="p-field-radiobutton">
                                                <RadioButton
                                                    inputId="showAllDeliverablesView"
                                                    name="viewOption"
                                                    value="showAllDeliverables"
                                                    onChange={handleViewOptionChange}
                                                    checked={viewOption === 'showAllDeliverables'}
                                                />
                                                <label className="labels" htmlFor="showAllDeliverablesView" style={{ fontWeight: '100', marginLeft: '0.5rem' }}>
                                                    Mostrar Todos los Entregables
                                                </label>
                                            </div>
                                        </div>
                                        <div className="p-col-fixed" style={{ alignSelf: 'start' }}>
                                            {permissionsDeliverableCreate 
                                             ?
                                             <BtnCrearEntregables
                                                 idProjectProp={idProjectProp}
                                                 projectProp={projectProp}
                                                 getClientsProp={getClientsProp}
                                                 dateStartValidityProp={dateStartValidityProp}
                                                 dateEndValidityProp={dateEndValidityProp}
                                                 individualMonthReportProp={individualMonthReportProp}
                                                 setRunRenderProp={setRunRender}
                                                 runRenderProp={runRender}
                                                 reloadObjectiveProp={reloadObjectiveProp}
                                                 runRenderBlockProp={runRenderBlockProp}
                                                 setRunRenderBlockProp={setRunRenderBlockProp}
                                                 deliverablesProp={deliverablesProp}
                                                 newDeliverablesProp={deliverables}
                                                 objectivesProp={objectivesProp}
                                                 projectsUserSessionProp={projectsUserSessionProp}
                                                 listDeliverableProp={deliverables} 
                                                 isMonthlyRepProp = {isMonthlyRep}
                                             />
                                             :
                                             <></>
                                            }
                                        </div>
                                    </div>
                                    {viewOption === 'multiSelect' && (
                                        <div className="p-field p-col-12 p-md-3" style={{ marginTop: '0.5rem' }}>
                                            <label className="labels" htmlFor="projectFilter" style={{ fontWeight: '500' }}>
                                                Filtrar por Proyectos:
                                            </label>
                                            <MultiSelect
                                                id="projectFilter"
                                                value={projectFilter}
                                                options={projects}
                                                onChange={handleProjectsChange}
                                                placeholder="Seleccione uno o más Proyectos"
                                                disabled={loadingProj}
                                                maxSelectedLabels={3}
                                                filter
                                                selectedItemsLabel={projectFilter?.length > 0 ? `${projectFilter.length} Elementos Seleccionados` : undefined}
                                                showClear
                                                className="p-column-filter"
                                            />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div className="p-grid" style={{ alignItems: 'start' }}>
                                        <div className="p-field p-col-12 p-md-5" style={{ marginTop: '5px' }}>
                                            <label className="labels" htmlFor="projectFilter" style={{ fontWeight: '500' }}>
                                                Filtrar por Proyectos:
                                            </label>
                                            <MultiSelect
                                                id="projectFilter"
                                                value={projectFilter}
                                                options={projects}
                                                onChange={handleProjectsChange}
                                                placeholder="Seleccione uno o más Proyectos"
                                                disabled={loadingProj}
                                                maxSelectedLabels={3}
                                                filter
                                                selectedItemsLabel={projectFilter?.length > 0 ? `${projectFilter.length} Elementos Seleccionados` : undefined}
                                                showClear
                                                className="p-column-filter"
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-7" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                                            {permissionsDeliverableCreate 
                                                ?
                                                <BtnCrearEntregables
                                                    idProjectProp={idProjectProp}
                                                    projectProp={projectProp}
                                                    getClientsProp={getClientsProp}
                                                    dateStartValidityProp={dateStartValidityProp}
                                                    dateEndValidityProp={dateEndValidityProp}
                                                    individualMonthReportProp={individualMonthReportProp}
                                                    setRunRenderProp={setRunRender}
                                                    runRenderProp={runRender}
                                                    reloadObjectiveProp={reloadObjectiveProp}
                                                    runRenderBlockProp={runRenderBlockProp}
                                                    setRunRenderBlockProp={setRunRenderBlockProp}
                                                    deliverablesProp={deliverablesProp}
                                                    newDeliverablesProp={deliverables}
                                                    objectivesProp={objectivesProp}
                                                    projectsUserSessionProp={projectsUserSessionProp}
                                                    listDeliverableProp={deliverables}
                                                    isMonthlyRepProp = {isMonthlyRep}
                                                />
                                                :
                                                <></>
                                                }
                                        </div>
                                    </div>
                                </>
                            )}
                            <Divider />
                        </>
                    )}
                </div>
                {showAllDataProp ?
                    <DataTable ref={dt} value={deliverablesProp} dataKey="id" className="p-datatable-responsive-demo" header={header} globalFilter={globalFilter}
                        emptyMessage="Entregable no registrado en el sistema" paginator rows={10} loading={loadingProp} responsiveLayout={small ? "stack" : "scroll"} breakpoint="760px"
                    >                        
                        <Column className="columna" field="cliente" sortable header="Cliente" />
                        <Column className="columna" field="proyecto" sortable header="Proyecto" />
                        <Column className="columna" field="periodo" sortable header="Periodo" />
                        <Column className="columna" field="equipoTrabajo" sortable header="Equipo de Trabajo" />
                        <Column className="columna" field="nombreColaborador" sortable header="Nombre Colaborador" />
                        <Column className="columna" field="objetivo" sortable header="Objetivo" />
                        <Column className="columna" field="entregable" sortable header="Entregable" />
                        <Column className="columna" field="porcentajeCumplimiento" sortable header="%Cumplimiento" />
                        <Column className="columna" field="fechacumplimiento" sortable header="Fecha Cumplimiento" />
                    </DataTable>
                    :
                    <DataTable ref={dt} value={deliverables} dataKey="id" className="p-datatable-responsive-demo" header={header} globalFilter={globalFilter}
                        paginator rows={5} sortField={individualMonthReportProp === true ? "" : "descripcion"} sortOrder={1}
                        loading={individualMonthReportProp ? loadingProp : loading}
                        selection={readReportProp ? null : selectedDeliverable} onSelectionChange={readReportProp ? null : e => onSelectedDeliverableChange(e)}
                        selectionMode={individualMonthReportProp === true ? "checkbox" : null}
                        onRowUnselect={readReportProp ? null : onRowUnselect} onRowSelect={readReportProp ? null : onRowSelect}
                        emptyMessage={selectedObjectiveProp?.length === 0 ? "Debe seleccionar primero un objetivo para este proyecto, luego podrá gestionar los entregables del proyecto" : "Entregable no registrado en el sistema"}
                    >
                        {individualMonthReportProp === true ?
                            showAllDataProp ?
                                null
                                :
                                readReportProp ?
                                    null
                                    :
                                    <Column selectionMode="multiple" style={{ maxWidth: '1rem' }} ></Column>
                            :
                            <></>
                        }
                        <Column className="columna" field="id" sortable header="Id Entregable" />
                        <Column className="columna" field="descripcion" sortable header="Entregable" />
                        {individualMonthReportProp === true ?
                            <Column className="columna" field="creadopor" sortable header="Creado por" />
                            :
                            <></>
                        }
                        {showAllDataProp ?
                            null
                            :
                            permissionsColumnActions ?
                                <Column header="Acciones" body={acctions} />
                                :
                                <Column />
                        }
                    </DataTable>
                }
                {individualMonthReportProp === true && disabledIndexProp === true && loadingProp === false ?
                    <div className="p-fluid p-formgrid p-grid" style={{ alignItems: 'baseline' }}>
                        <div style={{ display: 'contents' }} >
                            <div className="p-field p-col-12 p-md-12" style={{ marginTop: '15px' }}>
                                <Message severity="warn" text="Debe guardar los datos para cambiar de pestaña" />
                            </div>
                        </div>
                    </div>
                    :
                    null
                }
            </div>
        </div>
    )
}

export default ConsultarEntregables